import React from 'react';
import CreateGameCategoryState from './createGameCategoryState/CreateGameCategoryState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import ModalWindows from './components/ModalWindows/ModalWindows';
import Forms from './components/Forms/Forms';

const CreateGameCategoryPage: React.FC = () => {
	return (
		<CreateGameCategoryState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</CreateGameCategoryState>
	);
};

export default CreateGameCategoryPage;
